import mixpanel from "mixpanel-browser"
import { PAYMENT_EVENTS } from "."

export interface ExitBasicPlanProps {
  features: string[]
  email: string
  subtotal: number
  currency: string
  registrationDate: string
  lastLifeUsage: string | null
  daysBetween: number
}

export function exitBasicPlan(props: ExitBasicPlanProps) {
  mixpanel.track(PAYMENT_EVENTS.EXIT_BASIC_PLAN, props)
}
